import React from 'react'; 
import axios from 'axios';


class formWizard extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            question: '',
            possibleAnswer: '',
            images: [],
        }


    }

    componentDidMount(){
        this.setState({
            question: this.props.question || ''
        });

        const headers = {
            'X-Access-Token': this.props.userdata.accessToken
        }

        axios.get(this.props.apiurl + '/api/images/gallery', { headers: headers }).then(res => {
            let gallery = []; 

            res.data.gallery.map((image) => {
                gallery.push(
                    {
                        url: this.props.apiurl + '/assets/' + this.props.userdata.userId + "/" + image,
                        name: '',
                        selected: false,
                        order: 0
                    }
                )
            });

            
            if (this.props.possibleImageAnswers.length > 0){
                let answers = this.props.possibleImageAnswers; 
                // console.log(answers); 
                answers.map(answer => {
                    if (answer.selected === true){
                        gallery.map(image => {
                            if (image.url === answer.url){
                                image.selected = true; 
                                image.name = answer.name || "";
                                image.order = answer.order; 
                            }
                        });
                        document.getElementById("image-tab" + this.props.index).click(); 
                    }
                });
            }
            
            this.setState({
                images: gallery
            })
        }).catch(err => {
            console.log(err);
        })
    }
    
   

    handleSetQuestion = (event) => {
        this.setState({
            question: event.target.value
        }); 

        this.props.handleSetQuestion(event, this.props.index); 
    }

    handlePossibleAnswer = (event) => {
        this.setState({ 
            possibleAnswer: event.target.value 
        }); 
    }

    handlePossibleAnswerKeypress = (event) => {
        if (event.key === "Enter") {
            this.props.handleAddPossibleAnswer(this.state.possibleAnswer, this.props.index);
            this.setState({
                possibleAnswer: ''
            });
        }
    };
    
    handleAddPossibleAnswer = () => {
        if (this.state.possibleAnswer != ''){
            this.props.handleAddPossibleAnswer(this.state.possibleAnswer, this.props.index)
            
        }
    }

    handleUploadImages = () => {
        console.log("this works"); 
    }

    handleSelectImage = (index, propIndex) => {
        let imgs = this.state.images.map(obj => {
            return Object.assign({}, obj)
        });

        imgs[index].selected = !imgs[index].selected; 

        let order = 0; 

        imgs.map(obj => {
            if (obj.selected === false){
                obj.order = 0; 
            }

            if (obj.order > order){
                order = obj.order;
            }

        }); 

        imgs[index].order = order + 1;
  
        this.setState({
            images: imgs
        }, () => this.props.handleAddPossibleImageAnswer(this.state.images, propIndex));
    }

    handleChangeImageName = (event, index, propIndex) => {
        let imgs = this.state.images.map(obj => {
            return Object.assign({}, obj); 
        });

        imgs[index].name = event.target.value; 

        this.setState({
            images: imgs
        }, () => this.props.handleAddPossibleImageAnswer(this.state.images, propIndex)); 

        console.log(this.state.images); 
    }

    render(){
        let possibleAnswersList = []; 
        
        this.props.possibleAnswers.map((answer, index) => {
            possibleAnswersList.push(
                <li className="list-group-item d-flex justify-content-between" key={index}>
                    {answer}
                    <a href="#" onClick={ () => this.props.deletePossibleAnswer(answer, this.props.index) }>&#10005;</a>
                </li>
            );
        });
        
        let gallery = []; 

        this.state.images.map((image, index) => {
            if (image.selected){
                gallery.push(

                    <div key={index} className="c c-selected">
                        <div className="c-head c-selected">Order: {image.order}</div>
                        <img src={image.url} className="c-image" alt="gallery image" />
                        <div className="c-foot">
                            <button className="btn btn-success btn-sm" onClick={ () => this.handleSelectImage(index, this.props.index) }>Select</button>
                            <label>Name</label>
                            <input type="text" className="c-input" value={image.name} onChange={ (event) => this.handleChangeImageName(event,index, this.props.index) } />
                        </div>
                    </div>

                   
                )
            }else{
                gallery.push(
                    <div key={index} className="c">
                        <div className="c-head">&nbsp;</div>
                        <img src={image.url} className="c-image" alt="gallery image" />
                        <div className="c-foot">
                            <button className="btn btn-outline-secondary btn-sm" onClick={ () => this.handleSelectImage(index, this.props.index) }>Select</button>
                            <label>Name</label>
                            <input type="text" className="c-input" disabled/>
                        </div>
                    </div>
                )

            }
          
            
        }); 



        return(
            <div className="card">
                <div className="card-header">
                    <div className="float-left">
                        <h5 className="card-title">Question {this.props.index + 1} </h5>
                    </div>
                    <div className="float-right">
                        <button className={'btn btn-sm mr-2 ' + (this.props.entry.multipleChoice ? 'btn-secondary' : 'btn-outline-secondary')} onClick={() => this.props.handleMultipleChoice(this.props.index)}>Multiple Choice</button>
                        <button className={'btn btn-sm mr-2 ' + (this.props.entry.required ? 'btn-secondary' : 'btn-outline-secondary')}  onClick={() => this.props.handleRequired(this.props.index)} >Required</button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={ () => this.props.deleteQuestion(this.props.index) }>Remove</button>
                        
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col">
                            <div className="form-group">
                                <label>Question</label>
                                <input type="text" className="form-control"
                                    value={ this.state.question }
                                    onKeyPress={ (event) => this.handleSetQuestion(event, this.props.index) }
                                    onChange={(event) => this.handleSetQuestion(event, this.props.index) } />
                            </div>
                        </div>
                        
                    </div>
                    <div className="row">
                        <div className="col">
                            <label>Possible Answers</label>

                            <div>
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <a 
                                            className="nav-link active" 
                                            id={ "text-tab" + this.props.index } 
                                            data-toggle="tab" 
                                            href={"#text" + this.props.index } 
                                            role="tab" 
                                            aria-controls="text" 
                                            aria-selected="true">Text Based Answers</a>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <a 
                                            className="nav-link" 
                                            id={"image-tab" + this.props.index } 
                                            data-toggle="tab" 
                                            href={"#image" + this.props.index } 
                                            role="tab" 
                                            aria-controls="image" 
                                            aria-selected="false">Image Based Answers</a>
                                    </li>
                                </ul>
                                <div className="tab-content" id="myTabContent">
                                    <div className="tab-pane fade show active" id={"text" + this.props.index } role="tabpanel" aria-labelledby="text-tab">
                                        <div className="mt-2 mb-2">
                                            <ul className="list-group list-group-flush">
                                                <b>{ possibleAnswersList }</b>
                                            </ul>
                                        </div>

                                        <div className="input-group">
                                            <input type="text" className="form-control" 
                                                value = { this.state.possibleAnswer }
                                                onKeyPress={ (event) => this.handlePossibleAnswerKeypress(event) }
                                                onChange={ (event) => this.handlePossibleAnswer(event) } />
                                        </div>

                                        <div className="input-group">
                                            <button className="btn btn-outline-secondary btn-sm mt-2 mr-2" type="button" onClick={ this.handleAddPossibleAnswer }>Add</button>
                                            <button className="btn btn-outline-secondary btn-sm mt-2 mr-2" type="button" onClick={() => this.props.handleYesNo(this.props.index)}> Yes / No</button>
                                        </div>


                                    </div>
                                    <div className="tab-pane fade" id={"image" + this.props.index } role="tabpanel" aria-labelledby="image-tab">
                                    <button 
                                        className={'btn btn-sm mr-2 mt-2 ' + (this.props.entry.showImageNames ? 'btn-secondary' : 'btn-outline-secondary')}  
                                        onClick={ () => this.props.handleShowImageNames(this.props.index) } >Show Image Names</button>
                                        <p>Select images in the order in which you would like for them to be displayed on the form.</p>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm">
                                                    <div style={{height: "400px", overflowY: "scroll"}}>
                                                        {gallery}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default formWizard; 

